import { getStage } from 'modules/app-config/stage'
import { STG, STG_ENV } from 'modules/app-config/stg-env'

// Employee Experience API Configuration
export const getEmployeeExperienceBaseUrl = () => {
  const stage = getStage()
  if (stage === STG) {
    return STG_ENV.enrollmentPlatformServiceBaseUrl
  }
  if (stage === 'prod') {
    return 'https://services.sureco.com'
  }
  return 'https://api.dev.surecolabs.com'
}
